import { createSelector } from 'reselect';

export const getActionTypes = createSelector(
    () => {
        return [{
            title: 'lead',
            value: 'lead'
        },{
            title: 'sale',
            value: 'sale'
        },{
            title: 'first_payment (FTD)',
            value: 'first_payment'
        },{
            title: 'replenish_payment (Other Deposit)',
            value: 'replenish_payment'
        },{
            title: 'aggregate',
            value: 'aggregate'
        }];
    }
);

export const getActionNames = createSelector(
    () => {
        return [{
            title: 'turnover_firstdep_deposit',
            value: 'turnover_firstdep_deposit'
        },{
            title: 'turnover_bet',
            value: 'turnover_bet'
        },{
            title: 'bet',
            value: 'bet'
        },{
            title: 'win',
            value: 'win'
        },{
            title: 'lose',
            value: 'lose'
        },{
            title: 'payout',
            value: 'payout'
        },{
            title: 'ggr',
            value: 'ggr'
        },{
            title: 'registration',
            value: 'registration'
        },{
            title: 'regconfirm',
            value: 'regconfirm'
        },{
            title: 'verified',
            value: 'verified'
        },{
            title: 'firstdep',
            value: 'firstdep'
        },{
            title: 'deposit',
            value: 'deposit'
        },{
            title: 'multiaccount',
            value: 'multiaccount'
        },{
            title: 'block',
            value: 'block'
        }];
    }
);